import range from 'lodash/range';
import moment from 'moment';

export default {

  // can only plan a month three months from the current/live month.
  allowedFutureMonths: range(3).map(i => moment().add(i + 1, 'months').month()),

  /* RewardsDashboard */

  selectedLang: null,
  selectedYear: moment().year(), // always default to current year.

  selectedMonth: null, // NB: this is zero-indexed!! the only place where this number is displayed
                       //     as one-indexed is the URL in the browser address bar.

  currentStoreAccountId: null,
  topRewards: [],
  retailers: [],
  storeAccountsById: {},
  storeEscrowsById: {},

  fetchingEscrows: false,

  ngcEndpoint: null,
  ngcEndpointList: [],
  ngcEndpointForStore: null,

  /* CreateStoreEscrowModal */

  createdStoreEscrow: false,
  creatingStoreEscrow: false,
  createStoreEscrowSubmitted: false,
  createStoreEscrowError: null,

  /* RewardsTable */

  fetchingStoreCatalog: false,

  exportingStoreData: false,
  exportedStoreData: false,
  exportStoreDataSuccess: false,

  /* RetailerItemModal */

  retailerItemFormMode: null, // oneOf(Object.keys(RetailerItemFormModes))
  writingRetailerItem: false,
  writingRetailerItemResource: {}, // for tracking the state of a RetailerItem as it's being created.
  writeRetailerItemSubmitted: false,
  createRetailerItemError: null,

  /* PurchaseInfoModal */

  viewingPurchaseInfo: false,
  viewingPurchaseInfoFor: null,
  fetchingStoreOrders: false,
  storeOrders: [],
  resendOrderEmailSubmittedFor: null,
  resentOrderEmailFor: null,

  /* StoreStockModal */

  storeStockFormMode: null, // oneOf(Object.keys(StoreStockFormModes))
  updatingStoreStockFor: null,
  updatingStoreStock: false,

  /* AutoSaveQuantityInput */

  quantityUpdateSubmittedFor: {},
  quantityUpdateErrors: {},
  quantityUpdateSuccesses: {}
};



// WEBPACK FOOTER //
// ./public/pages/Rewards/initialState.js